import { Form, InputNumber } from 'antd';
import React from 'react';
import { NumNotaProps } from './props';
import TittleFilter from '../TextFilter';

const SelectNumNota: React.FC<NumNotaProps> = ({ setNumNotas, label = 'Número da nota' }) => {
  const onChange = (values: any) => {
    setNumNotas(values);
    localStorage.setItem(`numNota${window.location.pathname}`, values);
  };

  return (
    <>
      <Form.Item label={<TittleFilter>{label}</TittleFilter>} name="numNota">
        <InputNumber onChange={onChange} min={0} type="number" style={{ width: '100%' }} />
      </Form.Item>
    </>
  );
};

export default SelectNumNota;
